<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits } from 'vue'

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    value: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits(['change'])

/*==================================================================*/
/*================== HANDLERS ======================================*/
/*==================================================================*/

const onChange = (newValue) => {
    
    newValue = newValue ? true : false;

    emits('change', newValue)

}
</script>

<template>

    <div class="c-checkbox">

        <v-checkbox
            class="c-inner-checkbox"
            :input-value="props.value"
            :value="props.value"
            :disabled="props.disabled"
            hide-details
            @change="onChange($event)"
        ></v-checkbox>

        <div class="c-content">

            <slot></slot>

        </div>

    </div>

</template>

<style scoped>

.c-checkbox{
    display: grid;
    grid-template-columns: max-content auto;
    grid-template-rows: max-content;
    align-items: center;
}

.c-inner-checkbox{
    margin: 0px;
    padding: 12px;
}

.c-inner-checkbox >>> .v-input--selection-controls__input{
    margin-right: 0px;
}

</style>
